import { render, staticRenderFns } from "./PostTextMod.vue?vue&type=template&id=6958d2e6"
import script from "./PostTextMod.vue?vue&type=script&lang=js"
export * from "./PostTextMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports